import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export function DateField({ value, onChange, testId, placeholder = "Pick a date", className = "", clearable = false, noFuture = false }) {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} data-value={value || ""}
          className={`inline-flex items-center justify-between gap-2 text-left ${className}`}>
          <span className={d ? "text-slate-100" : "text-slate-500"}>{d ? format(d, "MMM d, yyyy") : placeholder}</span>
          <CalendarDays className="h-4 w-4 shrink-0 text-[#007AFF]" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto rounded-[14px] border-black/5 p-0 shadow-xl" data-testid={`${testId}-sheet`}>
        <Calendar mode="single" selected={d} disabled={noFuture ? { after: new Date() } : undefined} toDate={noFuture ? new Date() : undefined} defaultMonth={d} onSelect={(x) => { if (x) { onChange(format(x, "yyyy-MM-dd")); setOpen(false); } }} />
        <div className="flex justify-between border-t border-black/5 px-3 py-2 text-[15px]">
          <button type="button" data-testid={`${testId}-today`} onClick={() => { onChange(format(new Date(), "yyyy-MM-dd")); setOpen(false); }} className="text-[#007AFF]">Today</button>
          {clearable && value && (
            <button type="button" data-testid={`${testId}-clear`} onClick={() => { onChange(""); setOpen(false); }} className="inline-flex items-center gap-1 text-[#FF3B30]"><X className="h-4 w-4" />Clear</button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
